import { render, staticRenderFns } from "./CloseValve.vue?vue&type=template&id=b8a9b1b0&scoped=true&"
import script from "./CloseValve.vue?vue&type=script&lang=js&"
export * from "./CloseValve.vue?vue&type=script&lang=js&"
import style0 from "./CloseValve.vue?vue&type=style&index=0&id=b8a9b1b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a9b1b0",
  null
  
)

export default component.exports